import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { RDListElement } from './list-element.class';
import { trigger, transition, query, animate, keyframes, style } from '@angular/animations';
import { RDDarkService } from '../dark.service';

@Component({
  selector: 'rd-list',
  template: `<div [class]="getListClass()">

  <ng-container *ngIf="search">
    <div class="searchField">
      <input [(ngModel)]="searchText" placeholder="Search">
    </div>
  </ng-container>

  <div *ngIf="currentList.length === 0; else list" class="noResult">
    Empty List
  </div>
  <ng-template #list>
    <div class="listContainer">
      <div *ngIf="sort" class="sortHeader" [style.font-size.px]="size + 1">
        <div class="sortName" (click)="changeSort()">
          <b>Name</b>
          <span *ngIf="sortType === 'nameAsc'" class="sortArrow"><i class="fas fa-arrow-up"></i></span>
          <span *ngIf="sortType === 'nameDesc'" class="sortArrow"><i class="fas fa-arrow-down"></i></span>
        </div>
        <div class="sortAuthor">
          <b>Author</b>
        </div>
      </div>

      <div [@listAnimation]="listAnimation ? currentList.length : false">
        <div *ngFor="let elem of currentList; let i = index">
          <ng-container *ngIf="i !== 0">
            <div class="limiter"></div>
          </ng-container>

          <div class="elemListContent {{elem.color}}List" (click)="selectFile(elem)" [style.font-size.px]="size">
            <div class="elemListName">
              <span class="elemListIcon"><i [class]="elem.icon"></i></span>
              <div class="elemListTitle">{{elem.title}}</div>
            </div>
            <div class="elemListAuthor">{{elem.author}}</div>
          </div>

        </div>
      </div>
    </div>
  </ng-template>
</div>
`,
  styles: [`.rdList{--limit-color:#f1f1f1;--text-color:black;transition:all .3s linear}.rdList .searchField{min-width:250px;width:30%;float:right;margin-right:5%;border-bottom:1px var(--limit-color) solid;background:0 0}.rdList .searchField input{width:100%;border:none;background-color:transparent;color:var(--text-color)}.rdList .noResult{width:100%;text-align:center;padding:18px;color:var(--text-color)}.rdList .limiter{width:100%;border-top:2px var(--limit-color) solid}.rdList .sortHeader{border-bottom:3px var(--limit-color) solid;width:100%;padding:6px;display:flex;box-sizing:border-box;color:var(--text-color)}.rdList .sortHeader .sortName{width:60%;cursor:pointer;padding:0 6px}.rdList .sortHeader .sortArrow{padding:0 6px}.rdList .sortHeader .sortAuthor{width:40%;padding:0 6px}.rdList .elemListContent{width:100%;padding:6px;display:flex;cursor:pointer;box-sizing:border-box;--main-color:#ba9e5a}.rdList .elemListContent *{padding:0 1px}.rdList .elemListContent:active{background-color:#e3e3e3}.rdList .elemListContent .elemListAuthor,.rdList .elemListContent .elemListIcon,.rdList .elemListContent .elemListTitle{overflow:hidden;text-overflow:ellipsis;color:var(--text-color)}.rdList .elemListContent .elemListIcon{min-width:30px}.rdList .elemListContent .elemListName{width:60%;display:flex;box-sizing:border-box}.rdList .elemListContent .elemListAuthor{width:40%;box-sizing:border-box}.rdList .elemListContent .elemListIcon,.rdList .elemListContent .elemListTitle:hover{color:var(--main-color)}.rdList .elemListContent.blueList{--main-color:#5a5aba}.rdList .elemListContent.greenList{--main-color:#72ba5a}.rdList .elemListContent.blue-lightList{--main-color:#5aa2ba}.rdList .elemListContent.redList{--main-color:#ba5a5a}.rdList .elemListContent.purpleList{--main-color:#a25aba}.rdList .elemListContent.orangeList{--main-color:#ba8a5a}.rdList .elemListContent.blackList{--main-color:black}.rdList.rdDark{--text-color:white}`],
  animations: [
    trigger('listAnimation', [
      transition('* => *', [
        query(':enter', animate('.3s ease-in', keyframes([
            style({opacity: 0.2, transform: 'translateY(-50%)', offset: 0}),
            style({opacity: 1, transform: 'translateY(0)', offset: 1.0}),
          ])), {optional: true}),
          query(':leave', animate('.3s ease-in', keyframes([
              style({opacity: 1, offset: 0}),
              style({opacity: 0, maxHeight: 0, transform: 'translateY(50%)', offset: 1.0}),
            ])), {optional: true})
      ])
    ])
  ]
})
export class RDListComponent implements OnInit {

  @Input() data: Array<RDListElement> = [];
  @Input() search = false;
  @Input() sort = false;
  @Input() size = 16;
  @Input() listAnimation = false;

  @Output() fileSelect: EventEmitter<any> = new EventEmitter();

  public searchText = '';
  public sortType = 'nameAsc';
  public dark = false;

  constructor(private darkService: RDDarkService) { }

  ngOnInit() {
    this.darkService.getDarkElement().subscribe(() => {
      this.dark = this.darkService.isDark();
    });
    this.dark = this.darkService.isDark();
  }

  getListClass() {
    return 'rdList ' + (this.dark ? 'rdDark' : '');
  }

  get currentList() {
    let list: Array<RDListElement> = [];
    if (this.search) {
      for (const elem of this.data) {
        if (elem.title.toLowerCase().match(this.searchText.toLowerCase()) ||
          elem.author.toLowerCase().match(this.searchText.toLowerCase())) {
          list.push(elem);
        }
      }
    } else {
      list = this.data;
    }
    if (this.sort) {
     if (this.sortType === 'nameAsc') {
       this.sortAsc('name', list);
     } else {
       this.sortDesc('name', list);
     }
    }
    return list;
  }

  sortAsc(param, list) {
    list.sort(function(elem1, elem2) {
      let param1, param2;
      if (param === 'name') {
        param1 = elem1.title;
        param2 = elem2.title;
      }
      if (param1 < param2) {
        return -1;
      } else if (param1 > param2) {
        return 1;
      } else {
        return 0;
      }
    });
  }

  sortDesc(param, list) {
    list.sort(function(elem1, elem2) {
      let param1, param2;
      if (param === 'name') {
        param1 = elem1.title;
        param2 = elem2.title;
      }
      if (param1 < param2) {
        return 1;
      } else if (param1 > param2) {
        return -1;
      } else {
        return 0;
      }
    });
  }

  changeSort() {
    this.sortType = (this.sortType !== 'nameAsc') ? 'nameAsc' : 'nameDesc';
  }

  selectFile(elem) {
    this.fileSelect.emit(elem.file);
  }

}
